import { Link, Paper, RadioGroup, FormControlLabel, Radio, Button } from "@mui/material";
import { useState } from "react";
import StorylineServerProxy from "../storyline-proxy/storyline-proxy";
import OpenInNewIcon from '@mui/icons-material/OpenInNew';

export function LinkNotAnalysed({ link, scrapReport, linksInStoryline, handleOpenClick }: any){
    return (
        <>
            { linksInStoryline.includes(link)?<i>Included - </i>:<></> }
            <Link target="child" href={link} onClick={() => { handleOpenClick(link, scrapReport)}}>{ link }</Link>
            <Link href={ link } target="_blank"><OpenInNewIcon /></Link>
            <br/>
        </>
    )
}

export function LinkAnalysed({ linkAnalysed, scrapReport, linksInStoryline, linksInStorylineReady, handleOpenClick, handleDeleteClick, markLinkAsIncluded }: any){

    const [selectedTitle, setSelectedTitle] = useState("extracted");


    const title = linkAnalysed.isArticle? (selectedTitle == "extracted"?linkAnalysed.extractedTitle:linkAnalysed.proposedTitle): (
        linkAnalysed.jobTitle
    )

    function handleCreateClicked(){
        let storyElement = {
            title: title,
            link: linkAnalysed.link,
            description: linkAnalysed.summary?linkAnalysed.summary:"",
            type: linkAnalysed.isArticle?"News":(linkAnalysed.isJob?"Job":"Unknown"),
            timestampFormatted: new Date(scrapReport.timestamp).toISOString().substring(0, 10),
            timestamp: scrapReport.timestamp
        }

        console.log(storyElement);
        
        const createRequest = StorylineServerProxy.createStoryElement(storyElement);
        if(!createRequest){
            return;
        }

        createRequest.then(response => {
            if(response === undefined){
                return;
            }
            markLinkAsIncluded(linkAnalysed.link);
            if(scrapReport.analysisResult){
                if(scrapReport.analysisResult.length == 1){
                    if(window.confirm("Scrap report fully processed - Delete it?")){
                        handleDeleteClick(scrapReport);
                    }
                }
            }
        })
    }


    return (
        <>
            { 
                linkAnalysed.isArticle?
                <Paper elevation={4} sx={{ padding:4}}>
                        <RadioGroup value={selectedTitle} onChange={target => { setSelectedTitle(target.currentTarget.value) }}>
                            <FormControlLabel value="extracted" control={<Radio />} label={ linkAnalysed.extractedTitle } />
                            <FormControlLabel value="proposed" control={<Radio />} label={ linkAnalysed.proposedTitle } />
                        </RadioGroup>
                        <br/>
                        { linkAnalysed.summary }
                        <br/>
                        <LinkNotAnalysed link={linkAnalysed.link} scrapReport={scrapReport} linksInStorylineReady={linksInStorylineReady} linksInStoryline={linksInStoryline} handleOpenClick={handleOpenClick}/>
                        <br/>
                        <Button onClick={handleCreateClicked}>Create</Button>
                </Paper>
            :
            linkAnalysed.isJob?
            <Paper elevation={4} sx={{padding: 4}}>
                { linkAnalysed.jobTitle }
                <br/>
                <LinkNotAnalysed link={linkAnalysed.link} scrapReport={scrapReport} linksInStoryline={linksInStoryline} linksInStorylineReady={linksInStorylineReady} handleOpenClick={handleOpenClick}/>
                <br/>
                <Button onClick={handleCreateClicked}>Create</Button>
            </Paper>
            :<LinkNotAnalysed link={linkAnalysed.link} scrapReport={scrapReport} linksInStorylineReady={linksInStorylineReady} linksInStoryline={linksInStoryline} handleOpenClick={handleOpenClick}/> }
        </>
    )
}
